import { render, staticRenderFns } from "./vcSearchPerson.vue?vue&type=template&id=72d8c6b8&"
import script from "./vcSearchPerson.vue?vue&type=script&lang=js&"
export * from "./vcSearchPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports